import { SVGProps } from "react";

const ChevronUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || "14"}
    height={props.height || "8"}
    viewBox="0 0 14 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.75 6.74995C12.75 6.74995 8.33107 0.750013 6.74995 0.75C5.16884 0.749986 0.75 6.75 0.75 6.75"
      stroke={props.color ? props.color : "#AFAFAE"}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default ChevronUp;
